export default {"src":"/pro/_next/static/media/spy.23dd1f15.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};